export enum Cy_Statistiky {
  title = 'statistiky-title',

  specifikaceTab = 'statistiky-specifikace-tab',

  form = 'statistiky-form',

  casovyUsek = 'statistiky-casovy-usek',
  status = 'statistiky-status',
  akce = 'statistiky-akce',
  typ = 'statistiky-typ',
  kodSablony = 'kod-sablony',
  rozliseniDat = 'statistiky-rozliseni-dat',
  zobrazeniDat = 'statistiky-zobrazeni-dat',

  graf = 'statistiky-graf',

  search = 'statistiky-search-button',
  clear = 'statistiky-clear-filter-button',
}

// readonly Cy_Statistiky = Cy_Statistiky;
// [attr.data-cy]="Cy_Statistiky.title"
